import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import NoticeBoardItem from './NoticeBoardItem';
import s from './NoticeBoard.scss';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const PrevArrow = props => {
  const { onClick, currentSlide, ga4Type } = props;
  return (
    <button
      {...props}
      onClick={() => {
        if (typeof onClick === 'function') {
          onClick();
          if (ga4Type) {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: ga4Type,
              label: 'backward',
              story_no: currentSlide + 1,
            });
          }
        }
      }}
    />
  );
};

const NextArrow = props => {
  const { onClick, currentSlide, ga4Type } = props;
  return (
    <button
      {...props}
      onClick={() => {
        if (typeof onClick === 'function') {
          onClick();
          if (ga4Type) {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: ga4Type,
              label: 'forward',
              story_no: currentSlide + 1,
            });
          }
        }
      }}
    />
  );
};

const Pagination = props => {
  const { index, ga4Type } = props;
  return (
    <button
      onClick={() => {
        if (ga4Type) {
          analyticsWrapper('ga4', {
            event: 'user_click',
            type: ga4Type,
            label: 'pagination',
            story_no: index + 1,
          });
        }
      }}
    >
      {index + 1}
    </button>
  );
};

const NoticeBoard = props => {
  const {
    boardItems,
    isWapView,
    dots,
    arrows,
    boardName,
    badge,
    seoEnabled,
    dataUrl,
    ga4Type,
  } = props;

  const [activeItem, setActiveItem] = useState(1);
  const [boardStateItems, setBoardStateItems] = useState(null);
  const [isLoading, setIsLoading] = useState(!seoEnabled);

  useEffect(() => {
    if (!boardItems.length && dataUrl) {
      // Make server request to get the items
    } else if (!seoEnabled && boardItems.length) {
      setBoardStateItems(boardItems);
      setIsLoading(false);
    } else if (seoEnabled && boardItems.length) {
      setBoardStateItems(boardItems);
    }
  }, []);

  const settings = {
    dots,
    infinite: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    draggable: isWapView,
    arrows: arrows && !isWapView,
    prevArrow: <PrevArrow ga4Type={ga4Type} />,
    nextArrow: <NextArrow ga4Type={ga4Type} />,
    customPaging: i => (
      <span>
        <Pagination index={i} ga4Type={ga4Type} />
      </span>
    ),
    beforeChange: (prev, next) => {
      setActiveItem(next + 1);
    },
    onSwipe: direction => {
      const directionEnum = { right: 'backward', left: 'forward' };
      if (ga4Type) {
        analyticsWrapper('ga4', {
          event: 'user_click',
          type: ga4Type,
          label: directionEnum[direction],
          story_no: activeItem,
        });
      }
    },
  };

  return (
    <div className={`${s.noticeBoardMainWrap}`}>
      {badge && <img className={s.nbBadge} src={badge} alt={boardName} />}
      {boardName && <h3>{boardName}</h3>}
      {isLoading && <LoaderSpinner />}
      {!seoEnabled &&
        boardStateItems && (
          <Slider {...settings}>
            {boardStateItems &&
              Array.isArray(boardStateItems) &&
              boardStateItems.map((boardItem, index) => (
                <NoticeBoardItem
                  boardItem={boardItem}
                  isWapView={isWapView}
                  index={index + 1}
                  ga4Type={ga4Type}
                />
              ))}
          </Slider>
        )}
      {seoEnabled &&
        boardItems && (
          <Slider {...settings}>
            {boardItems &&
              Array.isArray(boardItems) &&
              boardItems.map((boardItem, index) => (
                <NoticeBoardItem
                  boardItem={boardItem}
                  isWapView={isWapView}
                  index={index + 1}
                  ga4Type={ga4Type}
                />
              ))}
          </Slider>
        )}
    </div>
  );
};

NoticeBoard.propTypes = {
  boardItems: PropTypes.arrayOf(PropTypes.shape({})),
  isWapView: PropTypes.bool,
  dots: PropTypes.bool,
  arrows: PropTypes.bool,
  boardName: PropTypes.string,
  badge: PropTypes.string,
  seoEnabled: PropTypes.bool,
  dataUrl: PropTypes.string,
  ga4Type: PropTypes.string,
};

NoticeBoard.defaultProps = {
  boardItems: [],
  isWapView: false,
  dots: false,
  arrows: false,
  boardName: null,
  badge: null,
  seoEnabled: true,
  dataUrl: '',
  ga4Type: '',
};

export default NoticeBoard;
